import { Button, Link, Stack, Typography } from '@mui/material';

export const Buttons = () => {
  return (
    <Stack spacing={2}>
      <Typography variant="h2">Buttons</Typography>
      <Stack direction="row" alignItems="center" spacing={2}>
        <Button variant="contained">Button Contained</Button>
        <Button variant="outlined">Button Outlined</Button>
        <Button>Button Text</Button>
        <Link href="#">Link</Link>
      </Stack>
    </Stack>
  );
};
